/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElCheckbox as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "vip_dl"
};
var _hoisted_2 = {
  "class": "container"
};
var _hoisted_3 = {
  "class": "row"
};
var _hoisted_4 = {
  "class": "vip_dl_con"
};
var _hoisted_5 = {
  "class": "vip_dl_fr"
};
var _hoisted_6 = {
  "class": "vip_dl_fr2"
};
var _hoisted_7 = {
  "class": "denglu block"
};
var _hoisted_8 = {
  "class": "denglu1"
};
var _hoisted_9 = {
  "class": "denglu1_con1 block"
};
var _hoisted_10 = {
  "class": "zhuce_ul"
};
var _hoisted_11 = {
  "class": "li1"
};
var _hoisted_12 = {
  "class": "li2"
};
var _hoisted_13 = {
  "class": "li3"
};
var _hoisted_14 = ["src"];
var _hoisted_15 = {
  "class": "li4"
};
var _hoisted_16 = {
  "class": "agreement"
};
var _hoisted_17 = {
  "class": "li5"
};
import { ElMessage } from "element-plus";
import { getCaptcha, loginApi } from "@/api/login/login";
import store from "@/store";
import eventBus from '../event/mitt';
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup: function setup(__props) {
    var router = useRouter();
    var submitLoading = ref(false);
    var checkedBool = ref(true);
    var ruleFormRef = ref();
    var captchaData = ref({
      captchaKey: "",
      captchaValue: ""
    });
    var rules = reactive({
      username: [{
        required: true,
        message: "请输入登录用户名/邮箱/手机号码",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入登录密码",
        trigger: "blur"
      }],
      captchaCode: [{
        required: true,
        message: "请输入验证码",
        trigger: "blur"
      }]
    });
    function login(_x) {
      return _login.apply(this, arguments);
    }
    function _login() {
      _login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(formEl) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (formEl) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return formEl.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid, fields) {
                  var response;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!valid) {
                          _context.next = 10;
                          break;
                        }
                        submitLoading.value = true;
                        loginData.value.captchaKey = captchaData.value.captchaKey;
                        _context.next = 5;
                        return loginApi(loginData.value);
                      case 5:
                        response = _context.sent;
                        submitLoading.value = false;
                        if (response.code === 200 && response.data) {
                          ElMessage.success('登录成功');
                          eventBus.emit('isLogin', true);
                          store.commit('SET_TOKEN', response.data.tokenValue);
                          router.push("/info");
                        } else {
                          loginData.value.captchaCode = '';
                          captchaFunction();
                          ElMessage.error(response.msg);
                        }
                        _context.next = 11;
                        break;
                      case 10:
                        console.log("error submit!", fields);
                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _login.apply(this, arguments);
    }
    var loginData = ref({
      username: "",
      password: "",
      captchaKey: '',
      captchaCode: ""
    });
    function captchaFunction() {
      return _captchaFunction.apply(this, arguments);
    }
    function _captchaFunction() {
      _captchaFunction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var captcha;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return getCaptcha();
            case 3:
              captcha = _context3.sent;
              if (captcha && captcha.data) {
                captchaData.value = captcha.data;
              }
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error("Failed to fetch captcha:", _context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }));
      return _captchaFunction.apply(this, arguments);
    }
    onMounted(function () {
      captchaFunction();
    });
    return function (_ctx, _cache) {
      var _component_el_input = __unplugin_components_0;
      var _component_el_form_item = __unplugin_components_1;
      var _component_el_checkbox = __unplugin_components_2;
      var _component_router_link = _resolveComponent("router-link");
      var _component_el_button = __unplugin_components_3;
      var _component_el_form = __unplugin_components_4;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[9] || (_cache[9] = _createElementVNode("h1", {
        "class": "hidden-xs"
      }, "登录", -1)), _cache[10] || (_cache[10] = _createElementVNode("ul", {
        "class": "welcome"
      }, [_createTextVNode(" 欢迎来到IIFA大家庭。"), _createElementVNode("br"), _createTextVNode("请登录获取更多权限，IIFA助力您的职业生涯持续发展，培养世界思想领袖。 ")], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form, {
        rules: _unref(rules),
        model: _unref(loginData),
        ref_key: "ruleFormRef",
        ref: ruleFormRef
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", _hoisted_11, [_createVNode(_component_el_form_item, {
            prop: "username"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(loginData).username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(loginData).username = $event;
                }),
                placeholder: "请输入登录的邮箱"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })]), _createElementVNode("li", _hoisted_12, [_createVNode(_component_el_form_item, {
            prop: "password"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                type: "password",
                modelValue: _unref(loginData).password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(loginData).password = $event;
                }),
                placeholder: "请输入登录密码",
                style: {
                  "color": "#a9a9a9"
                }
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })]), _createElementVNode("li", _hoisted_13, [_createVNode(_component_el_form_item, {
            prop: "captchaCode",
            style: {
              "width": "70%"
            }
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(loginData).captchaCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(loginData).captchaCode = $event;
                }),
                placeholder: "请输入验证码"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createElementVNode("img", {
            title: "点击刷新",
            onClick: captchaFunction,
            style: {
              "cursor": "pointer"
            },
            src: _unref(captchaData).captchaValue
          }, null, 8, _hoisted_14)]), _createElementVNode("li", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("label", null, [_createVNode(_component_el_checkbox, {
            checked: _unref(checkedBool)
          }, null, 8, ["checked"]), _cache[5] || (_cache[5] = _createElementVNode("span", null, "同意", -1))]), _createElementVNode("span", {
            "class": "tongyi",
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return _unref(router).push('/privacy');
            })
          }, _cache[6] || (_cache[6] = [_createElementVNode("i", null, "《隐私协议》", -1)]))]), _createVNode(_component_router_link, {
            to: "/forgotPsd"
          }, {
            "default": _withCtx(function () {
              return _cache[7] || (_cache[7] = [_createElementVNode("span", {
                "class": "span1"
              }, "忘记密码?", -1)]);
            }),
            _: 1
          })]), _createElementVNode("li", _hoisted_17, [_createVNode(_component_el_button, {
            type: "primary",
            loading: _unref(submitLoading),
            onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
              return login(_unref(ruleFormRef));
            }, ["prevent"])),
            "class": "fasong"
          }, {
            "default": _withCtx(function () {
              return _cache[8] || (_cache[8] = [_createTextVNode("立即登录")]);
            }),
            _: 1
          }, 8, ["loading"])])])])];
        }),
        _: 1
      }, 8, ["rules", "model"])])])])])])])])]);
    };
  }
});